var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1659_39074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.539 22.5001C16.596 22.5001 21.5505 14.9956 21.5505 8.49906C21.5525 8.28806 21.5495 8.07706 21.5415 7.86606C22.5058 7.16743 23.3382 6.30299 24 5.31306C23.0987 5.70947 22.144 5.97127 21.1665 6.09006C22.1964 5.47462 22.9677 4.50608 23.337 3.36456C22.3699 3.93864 21.3108 4.34108 20.2065 4.55406C19.4643 3.7636 18.4821 3.23994 17.4121 3.0642C16.3421 2.88846 15.2441 3.07045 14.288 3.58197C13.3319 4.09349 12.5712 4.90601 12.1237 5.89365C11.6761 6.8813 11.5668 7.98896 11.8125 9.04506C9.85452 8.94735 7.93897 8.43893 6.19024 7.55281C4.44152 6.66669 2.89871 5.42268 1.662 3.90156C1.03437 4.98628 0.842925 6.26914 1.12651 7.48984C1.4101 8.71053 2.14747 9.77762 3.189 10.4746C2.40811 10.4493 1.64429 10.2396 0.96 9.86256V9.93006C0.961909 11.0661 1.35573 12.1668 2.07499 13.0462C2.79424 13.9255 3.79488 14.5299 4.908 14.7571C4.48541 14.8735 4.04885 14.9316 3.6105 14.9296C3.30138 14.9328 2.99275 14.9041 2.6895 14.8441C3.00359 15.8225 3.61616 16.678 4.44125 17.2906C5.26634 17.9032 6.26253 18.242 7.29 18.2596C5.54415 19.629 3.38887 20.3723 1.17 20.3701C0.778948 20.373 0.388119 20.3505 0 20.3026C2.25213 21.7388 4.8679 22.5012 7.539 22.5001Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1659_39074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twitter+icon.7f1eedbd7fae760d9c7ce121cf4cf169.svg";
export { ForwardRef as ReactComponent };